import * as React from 'react'
import ZipField from '../../../../molecules/zip-field'
import { TextField } from '@doordash/component-fields'

type FieldProps = {
  error: string
  name: string
  touched: boolean
  value: string
}

type ZipFieldSlideProps = {
  placeholder: string
  handleChange: (field: string, value: string) => void
  handleZipCode: (field: string, value: string) => void
  fields: FieldProps
  error: string
  anchorId: string
  initialValue?: string
}

export const ZipFieldSlide = ({
  placeholder,
  handleChange,
  handleZipCode,
  fields,
  error,
  anchorId,
  initialValue,
}: ZipFieldSlideProps) => {
  return (
    <ZipField
      type="zip"
      placeholder={placeholder}
      initialValue={initialValue}
      onChange={handleChange.bind(this, 'zipCode')}
      getLocation={handleZipCode}
      label="Zipcode"
      isLabelHidden
      anchorId={anchorId}
      isRounded={true}
      {...fields}
      error={fields.error || error}
      size={TextField.Sizes.Large}
    />
  )
}

export default ZipFieldSlide
